import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '@modules/auth/login/login.component';
import { PreviewPdfComponent } from '@shared/common-components/preview-pdf/preview-pdf.component';
import { AuthGuard } from '@shared/guard/auth.guard';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';

const routes: Routes = [

   { path: '', component: LoginComponent , pathMatch: 'prefix'},
  
  // { path: '', redirectTo: 'home', pathMatch: 'full'},
  // { path: 'login', component: LoginComponent , pathMatch: 'prefix'},
  //  { path: '', redirectTo: '/auth/login', pathMatch: 'full'},

  { path: 'preview-pdf/:id',pathMatch: 'full', component:PreviewPdfComponent},

  {
    path: '',
    component: ContentLayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () =>
           import('./modules/home/home.module').then(m => m.HomeModule),
        canActivate: [AuthGuard], data: { pageName: "Home" }
      },
      {
        path: 'search',
        loadChildren: () =>
          import('./modules/search/search.module').then(m => m.SearchModule),
         canActivate: [AuthGuard], data: { pageName: "Search"} 
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./modules/report/report.module').then(m => m.ReportModule),
          canActivate: [AuthGuard] 
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./modules/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: ':id',
        loadChildren: () =>
          import('./modules/project/project.module').then(m => m.ProjectModule),
          canActivate: [AuthGuard]
      },
    ]

  },

  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./modules/auth/auth.module').then(m => m.AuthModule),
      canActivate: [AuthGuard]
  },

  // {
  //   path: '**', redirectTo: 'psr/psr-input', pathMatch: 'full'
  // },

];

@NgModule({
  imports: [

    RouterModule.forRoot(
      routes,
      {preloadingStrategy: PreloadAllModules}
    )

  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
